export const featuredCertifications = [
  {
    name: '정보처리기사',
    org: '한국산업인력공단',
  },
  {
    name: 'AICE Associate',
    org: 'KT',
  },
];

export const otherCertifications = [
  { date: '2015.08', name: '정보기술자격(ITQ) 아래한글 B등급', org: '한국생산성본부' },
  { date: '2015.10', name: '정보기술자격(ITQ) 한글파워포인트(한쇼) A등급', org: '한국생산성본부' },
  { date: '2015.12', name: '정보기술자격(ITQ) 한글엑셀(한셀) B등급', org: '한국생산성본부' },
  { date: '2016.03', name: '디지털정보활용능력(DIAT) 프리젠테이션 고급', org: '한국정보통신진흥협회' },
  { date: '2016.03', name: '디지털정보활용능력(DIAT) 스프레드시트 고급', org: '한국정보통신진흥협회' },
  { date: '2016.03', name: '디지털정보활용능력(DIAT) 워드프로세서 고급', org: '한국정보통신진흥협회' },
  { date: '2016.05', name: 'GTQ(그래픽기술자격) 1급', org: '한국생산성본부' },
  { date: '2018.01', name: '컴퓨터활용능력 2급', org: '대한상공회의소' },
  { date: '2019.04', name: '컴퓨터그래픽기능사', org: '한국산업인력공단' },
  { date: '2019.09', name: '디지털정보활용능력(DIAT) 인터넷정보검색 고급', org: '한국정보통신진흥협회' },
  { date: '2021.02', name: '운전면허 1종 보통', org: '경찰청' },
];
